var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditarInformacion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rect\\xE1ngulo_1852",
    x: 4.75,
    y: 7,
    width: 149,
    height: 149,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.09
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-editar-informacion-usuario"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 158,
    height: 158
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "editar-informacion-usuario",
    clipPath: "url(#clip-editar-informacion-usuario)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1853",
    "data-name": "Rect\\xE1ngulo 1853",
    width: 153,
    height: 153,
    rx: 75,
    transform: "translate(2.75 3)",
    fill: "#dde4eb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 0, 0)",
    filter: "url(#Rect\\xE1ngulo_1852)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_1852-2",
    "data-name": "Rect\\xE1ngulo 1852",
    width: 137,
    height: 137,
    rx: 68.5,
    transform: "translate(10.75 11)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_412",
    "data-name": "Grupo 412",
    transform: "translate(-141.801 -388.441)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Sustracci\\xF3n_13",
    "data-name": "Sustracci\\xF3n 13",
    d: "M59.683,59.683H0v-7.46a8.854,8.854,0,0,1,3.262-6.517,25.852,25.852,0,0,1,7.924-4.664,54.1,54.1,0,0,1,9.791-2.8,49.267,49.267,0,0,1,8.864-.936,42.152,42.152,0,0,1,5.06.338l-2.94,2.94v9.568l10.211.145,8.366-8.366a21.732,21.732,0,0,1,6.532,4.418,8.463,8.463,0,0,1,2.612,5.878v7.46ZM29.841,29.842a14.925,14.925,0,0,1-5.809-28.67A14.926,14.926,0,0,1,35.65,28.67,14.837,14.837,0,0,1,29.841,29.842Z",
    transform: "translate(189.301 437.988)",
    fill: "#3f4d71"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ic_edit_24px",
    d: "M3,29.3v6.92H9.92l20.41-20.41-6.92-6.92ZM35.682,10.458a1.838,1.838,0,0,0,0-2.6L31.364,3.537a1.838,1.838,0,0,0-2.6,0L25.385,6.914l6.92,6.92Z",
    transform: "translate(220.427 450.102)",
    fill: "#42b883"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditarInformacion);
export default __webpack_public_path__ + "static/media/editar-informacion.995a833cac1b6adf93729bcef4870507.svg";
export { ForwardRef as ReactComponent };